<template>
  <div style="margin-bottom: 30px;">
    <!--可折叠-->
    <el-collapse value="1" accordion>
      <el-collapse-item name="1" title="礼品卡规格">
        <el-form
          :model="giftCardSpecInfo"
          ref="form"
          label-width="100px"
          inline
          disabled
        >
          <el-form-item label="主题">
            <el-input v-model="giftCardSpecInfo.topicName"></el-input>
          </el-form-item>
          <el-form-item label="卡片名称">
            <el-input v-model="giftCardSpecInfo.cardName"></el-input>
          </el-form-item>
          <el-form-item label="卡片封面">
            <img :src="giftCardSpecInfo.topicCover" class="avatar" />
          </el-form-item>
          <el-form-item label="祝福语">
            <el-input
              type="textarea"
              v-model="giftCardSpecInfo.blessingWords"
            ></el-input>
          </el-form-item>
          <el-form-item label="卡片面值" prop="amount">
            <el-input v-model="giftCardSpecInfo.amount"></el-input>
          </el-form-item>
          <el-form-item label="卡片类型" prop="cardType">
            <el-input v-model="giftCardSpecInfo.cardTypeName"></el-input>
          </el-form-item>
          <el-form-item label="有效期类型" prop="validType">
            <el-input v-model="giftCardSpecInfo.validTypeName"></el-input>
          </el-form-item>
          <el-form-item label="有效期">
            <el-input v-model="giftCardSpecInfo.validValue"></el-input>
          </el-form-item>
          <el-form-item label="状态" prop="status">
            <el-input v-model="giftCardSpecInfo.statusName"></el-input>
          </el-form-item>
          <el-form-item label="备注">
            <el-input
              type="textarea"
              v-model="giftCardSpecInfo.remark"
            ></el-input>
          </el-form-item>
        </el-form>
      </el-collapse-item>
    </el-collapse>
  </div>
</template>
<script>
export default {
  name: "GiftCardSpecInfo",
  props: {
    giftCardSpecInfo: {
      type: Object,
      default: () => {}
    }
  },
  components: {},
  data() {
    return {};
  },
  methods: {}
};
</script>
<style lang="scss" scoped>
.avatar {
  width: 360px;
  height: 100px;
  display: block;
}
</style>



// WEBPACK FOOTER //
// specInfo.vue?3e0bb2c8